import { render, staticRenderFns } from "./Handsontable.vue?vue&type=template&id=452f88f9&"
import script from "./Handsontable.vue?vue&type=script&lang=ts&"
export * from "./Handsontable.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports